import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'namesFormat',
    standalone: false
})
export class NamesFormatPipe implements PipeTransform {

    /**
     * Takes a user and returns a field of it
     */
    transform(value?: {name: string}[] | {name: string } | string) {
        if (!value) {
            return '';
        }

        if (typeof value === 'string') {
            return value;
        }

        if (Array.isArray(value)) {
            return value
                .map((v) => v.name.trim())
                .join(', ')
                .replace(/, ((?:.(?!, ))+)$/gm, ' & $1');
        } else {
            return value.name;
        }
    }
}
